<style lang="less" scoped src="@/assets/less/manage-space/base.less"></style>

<template>
    <div>
        <div class="px-sm-4">
            <b-overlay :show="loading">
                <div class="my-3 bg-white round-unify p-3">
                    <b-form @submit.stop.prevent="createdCategory">
                        <b-form-group
                            id="input-group-name"
                            :label="$t('labels.name')"
                            label-for="input-name"
                            label-class="label-align"
                            :description="$t('messages.resourceNameHelp')"
                        >
                            <b-form-input
                                id="input-name"
                                v-model="form['Name']"
                                type="text"
                                required
                                :placeholder="$t('placeholders.categoryname')"
                                class="rounded-pill"
                            ></b-form-input>
                        </b-form-group>

                        <b-form-group
                            id="input-group-description"
                            :label="$t('labels.descriptionoptional')"
                            label-for="input-description"
                            label-class="label-align"
                            :description="$t('messages.shortDescription')"
                        >
                            <b-form-textarea
                                id="input-description"
                                :placeholder="$t('placeholders.textoptional')"
                                rows="3"
                                style="border-radius: 16px"
                                v-model="form['Description']"
                            ></b-form-textarea>
                        </b-form-group>

                        <!-- Resources -->
                        <b-form-group
                            id="input-group-resources"
                            :label="$t('labels.resources')"
                            label-for="input-resources"
                            label-class="label-align"
                            :description="$t('messages.categoryResourcesHelp')"
                        >
                            <b-button variant="primary" v-b-modal.modal-add-resource>{{
                                $t('labels.addresource')
                            }}</b-button>
                            <b-table
                                striped
                                hover
                                :items="selectedResources"
                                :fields="fields"
                                sort-icon-left
                                stacked="md"
                                class="table table-borderless table-responsive w-100 d-md-table"
                            >
                                <template v-slot:cell(Actions)="row">
                                    <b-button
                                        size="sm"
                                        variant="danger"
                                        class="mr-2"
                                        @click="removeResourceFromCategory(row.item.ID)"
                                        >{{ $t('labels.remove') }}
                                    </b-button>
                                </template>
                            </b-table>
                        </b-form-group>

                        <div class="w-100 d-flex justify-content-between">
                            <b-button
                                variant="outline-danger"
                                type="button"
                                @click="hasHistory() ? $router.go(-1) : $router.push('/admin/booking/categories')"
                                >{{ $t('labels.cancel') }}
                            </b-button>
                            <b-button variant="primary" type="submit">{{ $t('labels.create') }}</b-button>
                        </div>
                    </b-form>
                </div>
            </b-overlay>
        </div>

        <!-- add resource -->
        <b-modal id="modal-add-resource" ref="modal" :title="$t('labels.addresource')" centered hide-footer>
            <b-table
                striped
                hover
                :items="allResources"
                :fields="fields"
                sort-icon-left
                stacked="md"
                class="table table-borderless table-responsive w-100 d-md-table"
            >
                <template v-slot:cell(Actions)="row">
                    <b-button
                        size="sm"
                        variant="danger"
                        class="mr-2"
                        v-if="containsObject(row.item)"
                        @click="removeResourceFromCategory(row.item.ID)"
                        >{{ $t('labels.remove') }}
                    </b-button>
                    <b-button size="sm" variant="primary" class="mr-2" v-else @click="selectedResources.push(row.item)"
                        >{{ $t('labels.add') }}
                    </b-button>
                </template>
            </b-table>
        </b-modal>
    </div>
</template>

<script>
import axios from 'axios';
import EventBus from '@/eventBus';

export default {
    name: 'CreateBookinCategory',

    data() {
        return {
            allResources: [],
            selectedResources: [],
            fields: [
                {
                    key: 'Name',
                    label: this.$t('labels.name'),
                    sortable: true,
                },
                {
                    key: 'Actions',
                    label: this.$t('labels.actions'),
                },
            ],

            loadingResources: false,
            loading: false,

            form: {
                Name: '',
            },
        };
    },
    created() {
        this.listResources();
    },

    watch: {
        tag: 'loadAutocompleteItems',
    },
    methods: {
        hasHistory() {
            return window.history.length > 2;
        },
        containsObject(obj) {
            let i;
            for (i = 0; i < this.selectedResources.length; i++) {
                if (this.selectedResources[i].ID === obj.ID) {
                    return true;
                }
            }

            return false;
        },

        removeResourceFromCategory(itemID) {
            // remove from selectedResources by item id
            this.selectedResources = this.selectedResources.filter((el) => el.ID !== itemID);
        },

        /**
         * listResources - return list of resources for space
         */
        listResources() {
            this.loadingResources = true;
            axios({
                method: 'GET',
                url: '/admin/booking/resource/list',
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    // Keep an empty first-use response from being treated as a failed request.
                    this.allResources =
                        response.data && Array.isArray(response.data.Resources) ? response.data.Resources : [];
                    this.loadingResources = false;
                })
                .catch((error) => {
                    console.log(error);
                    this.loadingResources = true;
                });
        },

        createdCategory() {
            this.loading = true;
            const resources = [];
            this.selectedResources.forEach((entry, index) => {
                resources.push(entry.ID);
            });
            this.form.Resources = resources;
            const data = JSON.stringify(this.form);
            axios({
                method: 'POST',
                url: '/admin/booking/category',
                data,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    this.loading = false;
                    const message = {
                        Message: this.$t('messages.bookingCategoryCreated'),
                        Details: '',
                    };
                    EventBus.$emit('INFO', message);

                    this.$router.push('/admin/booking/categories');
                })
                .catch((error) => {
                    console.log(error);
                    // todo error processing
                    this.loading = false;
                    const message = {
                        Message: this.$t('messages.bookingCategoryCreateFailed'),
                        Details: '',
                    };
                    EventBus.$emit('Error', message);
                });
        },
    },
};
</script>
